import { uniqueId } from 'lodash';
import React from 'react';

/**
 * A unique ID stored for the additional description text. This will be unique
 * for each rendered element and will survive re-renders.
 */
export function useAriaDescribedBySetting(prefix?: string): string {
  return React.useMemo(() => uniqueId(prefix), [prefix]);
}
